import { GridColDef } from '@mui/x-data-grid-pro';
import { formatCurrency, gridDateTimeFormatter } from '@shared/commonFunctions';
import { dataGridCol } from '@shared/components/grid/common';

export const adjustmentsGridColumns: GridColDef[] = [
  dataGridCol('createdTimeUtc', {
    flex: 1.8,
    minWidth: 100,
    headerName: 'Created On',
    valueFormatter: gridDateTimeFormatter,
  }),
  dataGridCol('amountFinanced', {
    headerName: 'Amount to Finance/Flat',
    flex: 1.5,
    minWidth: 100,
    valueFormatter: ({ value }) => formatCurrency(value),
  }),
  dataGridCol('adjPayOff', {
    flex: 1.5,
    minWidth: 100,
    headerName: 'Adjusted PayOff',
    valueFormatter: ({ value }) => formatCurrency(value),
  }),
  dataGridCol('totalAdjustment', {
    flex: 1.5,
    minWidth: 100,
    headerName: 'Total Adjustment',
    valueFormatter: ({ value }) => formatCurrency(value),
  }),
  dataGridCol('adjustedBy', {
    flex: 1.5,
    minWidth: 100,
    headerName: 'Adjusted by',
  }),
].map((gridColumn) => ({ disableColumnMenu: true, flex: 1, minWidth: 220, ...gridColumn }));

export const LENDER_CODES = {
  FLAG: 'FLAG',
  GLS: 'GLS',
  QLO: 'QLO',
  HUGHES:'HUGHES'
};

export const OL_CODES = {
  KIOL: 'KIOL',
  GSE: 'GSE',
  BLOL: 'BLOL',
  SKYOL: 'SKYOL',
  CPE: 'CPE',
  BEL: 'BEL',
  PFCOL: 'PFCOL',
  EECUOL: 'EECUOL',
  PLOL1: 'PLOL1',
  OFCUOL: 'OFCUOL',
};

export const meridianLenders = [
  'TRP',
  'SKY',
  'SKYOL',
  'BLOL',
  'CUD',
  'EECU',
  'ROGUE',
  'BECU',
  'EECUOL',
  'BL',
  'MAT'
];
